import Box from 'components/ui/box';
import { IoClose } from 'react-icons/io5';

interface Props {
  onClose: () => void;
  description: string;
}

export default function Modal({ onClose, description }: Props) {
  return (
    <div 
      className="fixed z-20 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box className="relative bg-oxford-blue border-electric-blue p-1 lg:p-8 flex flex-col w-[330px] justify-center items-center border-opacity-100 bg-opacity-100">
        <button 
          className="absolute -top-5 -right-5 button-close bg-slate-blue rounded-full p-1" 
          onClick={() => onClose()}
          aria-label="Fechar modal"
        >
          <IoClose size={30} className="text-white" aria-hidden="true" />
        </button>

        <div>
          <h1 id="modal-title" className="text-yellow text-center text-lg mb-4">Ops!</h1>

          <p id="modal-description">{description}</p>
        </div>
      </Box>
    </div>
  );
}
